module.exports = __webpack_public_path__ + "img/DS6204X6.156eb863.jpg";